import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Header, Page } from 'components';
import { Card, CardContent } from '@mui/material';
import StepInForm from './components/StepInForm';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3)
	},
	content: {
		marginTop: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	}
}));

const StepIn = () => {
	const classes = useStyles();

	return (
		<Page className={classes.root} title="Step In Follow Up">
			<Header module="Step In Follow Up" view="Management" />
			<Card className={classes.content}>
				<CardContent>
					<StepInForm />
				</CardContent>	
			</Card>		
		</Page>
	);
};

export default StepIn;